import React, { useState, useEffect } from 'react';
import DisplayableSheet from '../../../PackageBuilders/MultiPose/DisplayableSheet';
import styles from './CartItem.module.scss';
import { Link } from 'react-router-dom';
import routes from '../../../../routes';

export function getImageTypeTitle(title, sheet) {
  if (sheet?.imageType?.component) return title;

  const split = title.split(' ');
  split.shift();

  const str = split.join(' ').trim();
  const lastChar = str[str.length - 1] === 's' ? '' : 's';

  return `${str}${lastChar}`.trim();
}

const DetailedView = ({ orderPackageId, sheetsByTypeName, type = 'Sheets' }) => {
  const [forceRenderKey, setForceRenderKey] = useState(Date.now());

  useEffect(() => {
    // Check if we need to force a re-render due to recent edits
    const lastEditTimestamp = localStorage.getItem('lastEditTimestamp');
    const needsRefresh = localStorage.getItem('needsCartRefresh');
    
    if (lastEditTimestamp || needsRefresh) {
      setForceRenderKey(Date.now());
      
      // Clean up the flags
      localStorage.removeItem('lastEditTimestamp');
      localStorage.removeItem('needsCartRefresh');
    }
  }, [sheetsByTypeName]); // Re-run when sheets data changes

  const link = (sheet) => {
    if (sheet.addon?.isHoliday) {
      return (
        routes.holiday.edit(sheet.orderPackageId, { s: [sheet.id] })
      )
    }

    return routes.multiPoseEdit(orderPackageId, { sheetId: sheet.id, type })
  }

  return (
    // Two-column grid of print groups (designer, 07-22) -- 8x10s / 5x7s / 3x5s /
    // Wallets sit side by side instead of one long stack.
    <div className={styles.sheetGroups}>
      {Object.keys(sheetsByTypeName).map((key) => (
        <div className={styles.sheetsContainer} key={`${key}-${forceRenderKey}`}>
          <div className={styles.imageTypeTitle}>{getImageTypeTitle(key, sheetsByTypeName[key][0])}</div>
          <div className={styles.sheets}>
            {sheetsByTypeName[key].map((sheet, index) => {
              // Create a unique key that includes multiple data points AND the force render key
              const uniqueKey = `${sheet.id}-${sheet.backgroundId || 'no-bg'}-${sheet.foregroundId || 'no-fg'}-${sheet.poseId || 'no-pose'}-${forceRenderKey}-${index}`;

              // Every sheet gets the SAME cell width -- 8x10, wallets, and the
              // 5x7/3x5 combo included -- so prints read at one consistent size.
              return (
                <div className={styles.sheetCell} key={uniqueKey}>
                  <DisplayableSheet 
                    sheet={sheet}
                    key={uniqueKey} // Force complete re-mount when any data changes
                  >
                    <Link className={styles.sheetEditLink} to={link(sheet)}>
                      Edit
                    </Link>
                  </DisplayableSheet>
                </div>
              )
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DetailedView;